<template>
  <section class="assets_section noTopInnerPage container">
    <div class="row">
      <!--footer widget-->
      <div
          class="block-wrapper col-12 col-lg-12"
          v-if="['en', 'ar'].includes(lang)"
      >
        <div class="inner instrument-progress">
          {{ symbolDescription }}
        </div>
      </div>
      <div class="block-wrapper col-12 col-lg-4" v-if="assetData">
        <div class="footer-widget footer-widget1">
          <div class="inner instrument-progress instrument-progress3">
            <div class="content-wrapper" :class="{ opacity: showTradingHours }">
              <h3>{{ t("Instrument_Info") }}</h3>
              <div class="details details1">
                <div class="one">{{ t("Leverage") }}</div>
                <div class="three">{{ this.assetData.leverage }}</div>
              </div>
              <div class="details details2">
                <div class="one">{{ t("Lot_size") }}</div>
                <div class="three">{{ this.assetData.Lot_Size }}</div>
              </div>
              <div class="details details3">
                <div class="one">{{ t("Fixed_Spread") }}</div>
                <div class="three">{{ this.assetData.Fixed_Spread }}</div>
              </div>
              <!-- <div class="details details4">
                <div class="one">{{ t("Variable_Spread") }}</div>
                <div class="three">{{ this.assetData.ECN_Spread }}</div>
              </div> -->
              <div class="details details5">
                <div class="one">{{ t("Pip_Value") }}</div>
                <div class="three">{{ this.assetData.pip_value }}</div>
              </div>
              <div class="details details6">
                <div class="one">{{ t("Swap_sell") }}</div>
                <div class="three">{{ this.assetData.SWap_Short }}</div>
              </div>
              <div class="details details7">
                <div class="one">{{ t("Swap_buy") }}</div>
                <div class="three">{{ this.assetData.SWap_Long }}</div>
              </div>
              <div
                  class="future-contract-wrapper"
                  v-if="this.assetData.Future_Contract !== undefined"
              >
                <div class="details details8">
                  <div class="one">{{ t("Future_Contract") }}</div>
                  <div class="three">{{ this.assetData.Future_Contract }}</div>
                </div>
                <div class="details details9">
                  <div class="one">{{ t("Automatic_roll_over_date") }}</div>
                  <div class="three">
                    {{ this.assetData.Automatic_RollOver_Date.split(" ")[0] }}
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom-time" @click="toggleTradingHours()">
              <div class="first-line">
                <span class="text">{{ t("Trading_hours") }}</span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                >
                  <g transform="translate(612.862 3424.953) rotate(180)">
                    <path
                        class="a"
                        d="M608.862,3417.025h4l-2.052,2.158-1.948,2.26-2.052-2.26-1.948-2.158Z"
                    />
                    <rect
                        class="b"
                        width="7.987"
                        height="8"
                        transform="translate(604.868 3416.953)"
                    />
                  </g>
                </svg>
              </div>
              <div class="hours" v-show="showTradingHours">
                <div class="inner-first-line">
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="8"
                      viewBox="0 0 8 8"
                  >
                    <g transform="translate(612.862 3424.953) rotate(180)">
                      <path
                          class="a"
                          d="M608.862,3417.025h4l-2.052,2.158-1.948,2.26-2.052-2.26-1.948-2.158Z"
                      />
                      <rect
                          class="b"
                          width="7.987"
                          height="8"
                          transform="translate(604.868 3416.953)"
                      />
                    </g>
                  </svg>
                  <span class="text">{{ t("Trading_hours") }}</span>
                </div>
                <div class="box">
                  <ul>
                    <li v-for="(item, index) in weekDays" :key="index">
                      <div class="first">{{ t(item.label) }}</div>
                      <div class="last">
                        <label v-if="tradingHours[item.day] && tradingHours[item.day].length > 0">
                          <span
                              v-for="(hour, index2) in tradingHours[item.day]"
                              :key="index2"
                          >
                            {{ hour.From + " - " + hour.To }}
                            <i
                                v-show="
                                index2 !== tradingHours[item.day].length - 1
                              "
                            >,&nbsp;</i
                            >
                          </span>
                        </label>
                        <label v-else>{{ t("close") }}</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrapper col-12 col-lg-4" v-if="rawSocketData">
        <div class="footer-widget footer-widget-none">
          <div class="inner instrument-progress instrument-progress1">
            <h6>{{ t("Asstes_Traders_Trends") }}</h6>

            <div class="progressbar-line">
              <div class="progressbar">
                <div
                    class="fill"
                    :style="{ width: p(100 - assetData.Buyers) }"
                ></div>
              </div>
              <div class="buy-sell">
                <span class="sellers"
                >{{ t("Sellers") }} <span>{{ 100 - assetData.Buyers }}</span
                >%</span
                >
                <span class="buyers"
                >{{ t("Buyers") }} <span>{{ assetData.Buyers }}</span
                >%</span
                >
              </div>
            </div>
          </div>

          <div class="inner instrument-progress instrument-progress2">
            <h6>{{ t("Asstes_Daily_Statistic") }}</h6>

            <div class="progressbar-line daily-balance">
              <div class="progressbar">
                <div
                    class="fill_daily"
                    :class="{
                    'near-right': fillDaily > 88,
                    'tight-right': fillDaily > 95,
                    'tight-left': fillDaily < 5
                  }"
                    :style="{ width: p(fillDaily) }"
                >
                  <div class="arrow">
                    <span id="sellArrow">{{
                        visualPrice(price, "b", "d")
                      }}</span>
                  </div>
                </div>
              </div>
              <div class="assets-low-high">
                <span class="progressbar-edge low"
                >{{ t("Assets_Low") }}
                  <span>{{ rawSocketData.low }}</span></span
                >
                <span class="progressbar-edge high"
                >{{ t("Assets_High") }}
                  <span>{{ rawSocketData.high }}</span></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
          class="col-12 col-lg-4"
          v-if="rawSocketData && shouldPricePerformanceDisplayed"
      >
        <div class="footer-widget">
          <div class="inner instrument-progress">
            <h3>{{ t("Assets_Price_Performance") }}</h3>

            <div
                v-for="period in displayPeriods"
                :class="period"
                :key="period"
                class="progressbar-line performance"
            >
              <div class="progressbar">
                <div
                    class="number"
                    :class="
                    rawSocketData.calcData[period].num > 0
                      ? 'positive-changed'
                      : 'negative-changed'
                  "
                >
                  <span>{{ rawSocketData.calcData[period].num }}</span
                  >%
                </div>
                <div
                    class="graph fill"
                    :class="
                    rawSocketData.calcData[period].num > 0 ? 'plus' : 'minus'
                  "
                    :style="{
                    width: p(rawSocketData.calcData[period].graphWidth)
                  }"
                ></div>
              </div>
              <p>{{ displayTitleForPeriod(period) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import { visualPrice } from "@/utils/symbolsSocket";

export default {
  name: "instrumentOverview",
  props: ["symbol"],
  data() {
    return {
      displayPeriods: [
        "periodD1",
        "periodD7",
        "periodD30",
        "periodMN6",
        "periodMN12"
      ],
      weekDays: [
        { day: "Sunday", label: "assets_sunday" },
        { day: "Monday", label: "assets_monday" },
        { day: "Tuesday", label: "assets_tuesday" },
        { day: "Wednesday", label: "assets_wednesday" },
        { day: "Thursday", label: "assets_thursday" },
        { day: "Friday", label: "assets_friday" },
        { day: "Saturday", label: "assets_saturday" }
      ],
      showTradingHours: false,
      userCountry: null
    };
  },

  created() {
    this.setLoaderDisplay(false); //temporary, but works well for now since it get most of it's info as props
    this.getUserCountry();
  },
  computed: {
    ...mapState(["symbolsData", "lang"]),
    ...mapState("symbolsSocket", ["quotes", "initialSocketData"]),
    ...mapGetters(["t", "baseNewApiUrl"]),
    price: function() {
      return this.quotes[this.symbol];
    },
    rawSocketData: function() {
      return this.initialSocketData[this.symbol];
    },
    expiryDateDisplay: function() {
      const expiryDate = this.assetData.Expiry_Date;
      return expiryDate ? expiryDate.split(" ")[0] : "";
    },
    fillDaily: function() {
      return this.rawSocketData.output;
    },
    assetData: function() {
      return this.symbolsData[this.symbol];
    },
    symbolDescription: function() {
      const descriptionFromService = this.symbolsData[this.symbol]
          .symbol_description;
      if (descriptionFromService) {
        return descriptionFromService;
      } else {
        return this.t("No_data_yet");
      }
    },
    shouldPricePerformanceDisplayed: function() {
      return this.userCountry && this.userCountry != "GB";
    },
    tradingHours: function() {
      return typeof this.assetData.fullTradingHours === 'string' ? JSON.parse(this.assetData.fullTradingHours) : this.assetData.fullTradingHours;
    }
  },
  methods: {
    visualPrice: visualPrice,
    ...mapMutations(["setLoaderDisplay"]),
    p: function(val) {
      return val + "%";
    },
    displayTitleForPeriod: function(period) {
      let displayText;
      switch (period) {
        case "periodD1":
          displayText = "1D";
          break;
        case "periodD7":
          displayText = "7D";
          break;
        case "periodD30":
          displayText = "30D";
          break;
        case "periodMN6":
          displayText = "6M";
          break;
        case "periodMN12":
          displayText = "1Y";
          break;
        default:
          break;
      }
      return displayText;
    },
    toggleTradingHours: function() {
      this.showTradingHours = !this.showTradingHours;
    },
    async getUserCountry() {
		let serviceUrl = "https://geoip.multiforwarder.click/";
		this.userCountry = (await (await fetch(serviceUrl)).json()).country;
    }
  }
};
</script>

<style lang="scss" scoped>
.assets_section {
  color: #424242;
}

.spinner-border {
  margin: 20px auto 0;
  display: block;
}

header {
  background-color: #1c79be;
}

.main-text {
  margin-bottom: 24px;
}

.details {
  display: flex;
  margin: 5px auto 0;
  width: 100%;
  /*white-space: nowrap;*/
  line-height: 2.4;
}

.details:not(:last-of-type) {
  border-bottom: 1px solid #f5f5f5;
}

.details .one {
  text-align: left;
  flex-grow: 1;
}

.details .two,
.dash {
  background-color: #eeecec;
  max-width: 34%;
  width: 100%;
  height: 2px;
  margin-top: 11px;
  flex-grow: 2;
}

.details .three {
  width: 25%;
  text-align: right;
  padding-left: 8px;
  flex-grow: 1;
}

.bottom-time {
  margin-top: 23px;
  font-weight: 500;
  cursor: pointer;
  .first-line {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    svg {
      margin-inline-start: 8px;
      transform: rotate(90deg);
      .a {
        fill: #1c79be;
      }
      .b {
        fill: none;
      }
    }
  }
  .inner-first-line{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    svg{
      transform: rotate(-90deg);
      margin-inline-end: 8px;
      .a {
        fill: #000000;
      }
      .b {
        fill: none;
      }
    }
  }
  ul {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 0;
      border-bottom: 1px solid #e5e5e5;
      &:last-child {
        border-bottom: none;
      }
      label {
        margin: 0;
      }
      .first {
        min-width: 88px;
      }
      .last {
        text-align: right;
        &.multiHours {
          width: 70%;
          label {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-end;
          }
        }
      }
    }
  }
}

.opacity {
  opacity: 0.5;
}

.bottom-time .first-line .text {
  color: #1c79be;
}
.bottom-time .first-line {
  display: inline-flex;
  width: 100%;
}

.bottom-time .inner-first-line {
  border-bottom: 1px solid #bcbcbc;
  padding: 0 0 10px;
  display: flex;
}

.bottom-time .hours {
  position: absolute;
  left: 50%;
  bottom: 0;
  padding: 10px 20px;
  width: 100%;
  background-color: white;
  box-shadow: 0 -2px 6px 2px rgba(0, 0, 0, 0.1);
  z-index: 2;
  @media screen and (max-width: 991px) {
    left: 30%;
    width: 72%;
  }
}

.bottom-time .hours .day:nth-child(2) {
  padding-top: 10px;
}

.bottom-time .hours .day {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  font-size: 14px;
  white-space: nowrap;
  font-family: Lato;
  font-weight: normal;
}

//.bottom-time .hours .day span {
//  width: 25%;
//}

/*.chart-nav {*/
/*  position: absolute;*/
/*  left: 35px;*/
/*  top: 45px;*/
/*  z-index: 18;*/
/*  direction: ltr;*/
/*}*/

.assets_section {
  padding: 0 0 45px;
}

/*.assets_section .inner-new {*/
/*  border: 1px solid #BCBCBC;*/
/*}*/

.assets_section .inner.inner-one {
  height: 130px;
}

.assets_section .inner .wrap2 a {
  width: 170px;
  color: #1c75bb;
  border: 1px solid #1c75bb;
}

.assets_section .inner .wrap2 a:hover {
  background: #1c75bb;
  color: #fff;
}

.assets_section .inner .wrap2 a:hover span {
  color: #fff;
}

/*.scxValueScale.scxRightValueScale {*/
/*  display: none;*/
/*}*/

/*.scxContainer {*/
/*  max-width: 100%;*/
/*  right: 0;*/
/*}*/

/*.scxPanelTitle {*/
/*  display: none;*/
/*}*/

.assets_section .footer-widget {
  height: 100%;
}

.assets_section .inner .wrap1 {
  display: flex;
  padding: 0 25px;
}

.assets_section .inner .wrap1 .img-wrapper {
  margin: 0 15px 0 0;
}

.assets_section .inner .wrap1 .img-wrapper img {
  height: 70px;
  width: 70px;
}

.assets_section .inner .wrap1 .instrument {
  line-height: normal;
  direction: ltr;
  margin-left: 1rem;
}

.assets_section .inner .wrap1 .instrument strong {
  font-size: 40px;
}

.assets_section .inner .wrap1 .instrument p {
  font-size: 17px;
  font-weight: bold;
}

.assets_section .inner .wrap1 .percent {
  padding-top: 10px;
}

.assets_section .inner .wrap1 .percent p {
  color: #85c446;
  font-size: 22px;
  font-weight: bold;
  padding-left: 10px;
  border-left: 1px solid grey;
  line-height: 20px;
}

.assets_section .inner .wrap2 {
  display: flex;
  justify-content: flex-end;
  padding-left: 15px;
}

.assets_section .inner .wrap2 a {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  margin-right: 27px;
  padding: 10px 15px;
  border: 1px solid #1c75bb;
  cursor: pointer;
}

body.lang-es .assets_section .inner .wrap2 a {
  font-size: 16px;
}

.assets_section .inner .wrap2 a:first-of-type {
  margin-right: 15px;
}

.assets_section .inner .wrap2 span {
  margin-left: 5px;
}

.block-wrapper:not(.col-lg-4) {
  margin-bottom: 1.5rem;
}

.assets_section .inner.instrument-progress {
  border: 1px solid #d5d3d3;
  border-radius: 3px;
  padding: 24px;
  background-color: #ffffff;
}

.assets_section .inner.instrument-progress1,
.assets_section .inner.instrument-progress2 {
  display: flex;
  flex-direction: column;
  /*justify-content: space-between;*/
}

.assets_section .inner.instrument-progress1 {
  margin-bottom: 1.5rem;
}

.assets_section .inner.instrument-progress3 {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  /*justify-content: space-between;*/
}

.assets_section .inner.instrument-progress {
  h3,
  h6 {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 24px;
  }
}

.assets_section .inner.instrument-progress2 h6 {
  margin-bottom: 47px;
}

.assets_section .inner.instrument-progress .daily-balance .progressbar .fill {
  background-color: transparent;
}

.assets_section .inner.instrument-progress .daily-balance .progressbar .arrow {
  width: 1px;
  height: 100%;
  float: right;
  background: white;
  position: relative;
}

.assets_section
.inner.instrument-progress
.daily-balance
.progressbar
.fill_daily {
  .arrow #sellArrow {
    position: absolute;
    top: -25px;
    left: -15px;
    font-size: 14px;
    @media screen and (max-width: 991px) {
      top: -31px;
    }
  }
  @media screen and (max-width: 991px) {
    &.tight-left {
      .arrow #sellArrow {
        left: -6px;
      }
    }
    &.near-right {
      .arrow #sellArrow {
        left: -30px;
      }
    }
    &.tight-right {
      .arrow #sellArrow {
        left: unset;
        right: -6px;
      }
    }
  }
}

.assets_section
.inner.instrument-progress
.daily-balance
.progressbar
.arrow::before {
  content: "";
  background: url("../assets/images/components/instrumentOverview/arrow-marker.svg")
  center / 100% no-repeat;
  /*todo: return arrow*/
  width: 10px;
  height: 10px;
  position: absolute;
  top: -10px;
  right: -5px;
}

.assets_section .container .row:first-of-type {
  height: 100%;
  justify-content: space-between;
  align-items: center;
}

.assets_section .inner .progressbar-line {
  position: relative;
  z-index: 1;
}
.assets_section .buy-sell {
  direction: ltr;
  margin-top: 10px;
}

.assets_section .assets-low-high {
  margin-top: 8px;
}
.assets_section .buy-sell,
.assets_section .assets-low-high {
  display: flex;
  justify-content: space-between;
  text-align: center;
  font-size: 14px;
  direction: ltr;
}

.assets_section .progressbar-edge {
  line-height: 1.2;
  text-align: center;
  font-size: 14px;
}

.assets_section .buyers {
  color: #85c446;
}

.assets_section .sellers {
  color: #f26b4f;
}

.assets_section .inner .progressbar-line .progressbar {
  position: relative;
  width: 100%;
  height: 6px;
  background-color: #85c446;
}

.assets_section .inner .progressbar-line .progressbar .fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: #f26b4f;
}

/*.assets_section .container .row .chart-container-box .chart-inner {*/
/*  padding: 20px;*/
/*  margin: 25px 0;*/
/*}*/

.assets_section .inner .progressbar-edges {
  display: flex;
  justify-content: space-between;
  color: #000;
}

.assets_section .inner .progressbar-line.daily-balance .progressbar-edge {
  /*color: #1C79BE;*/
}
.assets_section .inner .progressbar-line.daily-balance .progressbar {
  background-color: #1c79be;
}

.assets_section .inner .progressbar-line.performance {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin-top: 2rem;
}

.assets_section .inner .progressbar-line.performance .progressbar {
  top: 7px;
  max-width: 84%;
  width: 100%;
  background-color: #e5e5e5;
}

.assets_section .inner .progressbar-line.performance .fill.plus {
  background-color: #85c446;
  left: 50%;
  right: 0;
}

.assets_section .inner .progressbar-line.performance .fill.minus {
  background-color: #f26b4f;
  right: 50%;
  left: inherit;
  direction: rtl;
}

.assets_section .inner .progressbar-line.performance p {
  margin-left: 10px;
}

.positive-changed,
.negative-changed {
  position: absolute;
  bottom: 5px !important;
  font-size: 14px;
}

.positive-changed {
  color: #85c446;
  left: 50%;
  bottom: 14px;
}

.negative-changed {
  color: #f26b4f;
  right: 50%;
}

.positive-changed-main {
  color: #85c446;
}

.negative-changed-main {
  color: #f26b4f;
}

/*.scx-icon {*/
/*  width: 40px;*/
/*  height: 43px;*/
/*}*/

/*.mobile-tools .scx-icon {*/
/*  top: 12px !important;*/
/*}*/

/*!* top buttons*!*/
/*#btnGroupDrop1 span.image#image-theme {*/
/*  color: #555;*/
/*}*/

/*#btnGroupDrop1 .scx-icon {*/
/*  width: 21px;*/
/*  height: auto;*/
/*  top: 0;*/
/*}*/

/*.assets_section .btn,*/
/*.show > .btn-light.dropdown-toggle,*/
/*.show > .btn-light.dropdown-toggle:focus {*/
/*  !*padding: .375rem .75rem !important;*!*/
/*  font-size: 1rem !important;*/
/*  display: flex;*/
/*  padding: 0;*/
/*  width: 165px;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*  border: 1px solid #cfcfcf;*/
/*  background-color: #fff;*/
/*  box-shadow: none;*/
/*}*/

/*.btn-group {*/
/*  height: 39px;*/
/*  margin-bottom: 10px;*/
/*}*/

/*.icon-period-big {*/
/*  font-size: 14px;*/
/*  color: #555;*/
/*  display: inline-block;*/
/*  vertical-align: middle;*/
/*  font-weight: 700;*/
/*}*/

/*.icon-period-small {*/
/*  font-size: 11px;*/
/*  margin-top: -5px;*/
/*  line-height: 0;*/
/*  color: #555;*/
/*}*/

/*.mobile-tools .icon-period-small {*/

/*}*/

/*.scxToolbar {*/
/*  display: none !important;*/
/*}*/

/*.mobile-tools .icon-period-big {*/

/*}*/

/*!* bar *!*/
/*.chart-nav .scx-icon .bar.image:before {*/
/*  content: "\6a" !important;*/
/*}*/

/*!* coloredBar *!*/
/*.chart-nav .scx-icon .coloredBar.image {*/
/*  !*position: relative;*!*/
/*  !*width: 100%;*!*/
/*  !*height: 100%;*!*/
/*}*/

/*.chart-nav .scx-icon .coloredBar.image:before {*/
/*  content: "\6e" !important;*/
/*  !*position: absolute;*!*/
/*  !*top: 9px;*!*/
/*  !*left: 9px;*!*/
/*  !*width: 22px !important;*!*/
/*  !*height: 22px;*!*/
/*  color: #FFC107;*/
/*}*/

/*.chart-nav .scx-icon .coloredBar.image:after {*/
/*  content: "\6f" !important;*/
/*  !*position: absolute;*!*/
/*  !*top: 10px;*!*/
/*  !*right: 9px;*!*/
/*  !*width: 22px !important;*!*/
/*  !*height: 22px;*!*/
/*  !*font-size: 22px;*!*/
/*  color: #F75B54;*/
/*}*/

/*.chart-nav .scx-icon .coloredBar.image {*/
/*  !*height: 40px;*!*/
/*  !*width: 40px;*!*/
/*}*/

/*.chart-nav .scx-icon .coloredBar.image:before {*/
/*  !*top: 9px;*!*/
/*  !*left: 21px;*!*/
/*}*/

/*.chart-nav .scx-icon .coloredBar.image:after {*/
/*  !*top: 14px;*!*/
/*  !*right: 22px;*!*/
/*}*/

/*!* candle *!*/
/*.chart-nav .scx-icon .candle.image:before {*/
/*  content: "\6b" !important;*/
/*}*/

/*!* hollowCandle *!*/
/*.chart-nav .scx-icon .hollowCandle.image:before {*/
/*  content: "\49" !important;*/
/*}*/

/*!* heikinAshi *!*/
/*.chart-nav .scx-icon .heikinAshi.image:before {*/
/*  content: "\48" !important;*/
/*}*/

/*!* renko *!*/
/*.chart-nav .scx-icon .renko.image:before {*/
/*  content: "\35" !important;*/
/*}*/

/*!* lineBreak *!*/
/*.chart-nav .scx-icon .lineBreak.image:before {*/
/*  content: "\51" !important;*/
/*}*/

/*!* kagi *!*/
/*.chart-nav .scx-icon .kagi.image:before {*/
/*  content: "\4e" !important;*/
/*}*/

/*!* line *!*/
/*.chart-nav .scx-icon .line.image:before {*/
/*  content: "\4f" !important;*/
/*}*/

/*!* mountain *!*/
/*.chart-nav .scx-icon .mountain.image:before {*/
/*  content: "\53" !important;*/
/*}*/

/*!* pointAndFigure *!*/
/*.chart-nav .scx-icon .pointAndFigure.image:before {*/
/*  content: "\57" !important;*/
/*}*/

/*.mobile-tools .container .tools-row {*/
/*  background-color: #F4F4F4;*/
/*  position: relative;*/
/*  top: -5px;*/
/*}*/

/*.mobile-tools .container .row .col {*/
/*  text-align: center;*/
/*}*/

.footer-widget.footer-widget-none {
  display: flex;
  flex-direction: column;
  /*justify-content: space-between;*/
  height: 100%;
}

/*#optionsChartDisplayList {max-height: 275px; overflow-y: scroll;}*/
/*#optionsChartDisplayList .dropdown-item{display: flex;justify-content: flex-start;align-items: center;}*/
/*#optionsChartDisplayList .dropdown-item .button.scx-icon{display: flex;justify-content: center;align-items: center;width: auto;height: auto;margin:10px 10px 10px 0;}*/
/*#optionsChartDisplayList .dropdown-item .button.scx-icon .image.coloredBar:before{position: absolute;}*/

@media screen and (max-width: 991px) {
  header {
    height: 60px;
  }

  .modal-backdrop {
    position: inherit;
  }

  .assets_section {
    padding: 60px 0 20px;
  }

  /*.mobile-tools .container .tools-row {*/
  /*  top: 0;*/
  /*  background-color: inherit;*/
  /*  border-top: 1px solid #C4C1C1;*/
  /*}*/

  /*.mobile-tools .container .tools-row button {*/
  /*  border: none;*/
  /*  background: transparent;*/
  /*  height: 100%;*/
  /*}*/

  /*.mobile-tools .container .row .col:last-of-type {*/
  /*  border-left: 1px solid #C4C1C1;*/
  /*}*/

  .assets_section .container .row:last-of-type .col-12:first-of-type {
    order: 1;
  }

  .assets_section .container .row:last-of-type .col-12:nth-child(3) {
    order: 2;
  }

  .assets_section .container .row:last-of-type .col-12:last-of-type {
    order: 3;
  }

  .assets_section .container .row:last-of-type .col-12:nth-child(2) {
    order: 4;
  }

  .assets_section .inner .wrap1 {
    position: relative;
    padding: 0 10px;
  }

  .assets_section .inner .wrap1 .img-wrapper {
    margin: 0 5px 0 0;
  }

  .assets_section .inner .wrap1 .img-wrapper img {
    width: 36px;
    height: 36px;
  }

  .assets_section .inner .wrap1 .instrument p {
    font-size: 16px;
    line-height: 1.2;
    font-family: Lato;
  }

  .assets_section .inner .wrap1 .instrument strong {
    font-size: 18px;
  }

  .assets_section .inner .wrap1 .percent {
    position: absolute;
    right: 0;
    padding: 0;
  }

  .assets_section .inner .wrap1 .percent p {
    border-left: none;
    font-size: 14px;
    padding: 0;
  }

  .assets_section .inner .wrap2 {
    margin-top: 15px;
    justify-content: space-evenly;
  }

  .assets_section .inner .wrap2 a {
    margin-right: 0;
    padding: 10px 20px;
    font-size: 16px;
    width: 50%;
  }

  .block-wrapper,
  .block-wrapper:not(.col-lg-4) {
    margin-bottom: 1rem;
  }

  .inner.instrument-progress.instrument-progress1 {
    margin-bottom: 1rem;
  }

  .inner.instrument-progress.instrument-progress2 {
    order: 2;
  }

  .assets_section .inner.instrument-progress {
    padding: 20px 10px;
  }

  .assets_section
  .inner.instrument-progress
  .daily-balance
  .progressbar
  .arrow::before {
    width: 17px;
    height: 17px;
    top: -17px;
    right: -8.5px;
  }

  .assets_section
  .inner.instrument-progress
  .daily-balance
  .progressbar
  .arrow
  #sellArrow {
    top: -31px;
  }

  .details .three {
    font-size: 14px;
  }

  .details.details {
    justify-content: space-evenly;
  }

  .assets_section .footer-widget {
    height: inherit;
  }

  .assets_section .footer-widget .inner .instrument-progress {
    padding: 12px;
  }

  .inner.instrument-progress.instrument-progress1 {
    order: 1;
  }

  .inner.instrument-progress.instrument-progress2 {
    order: 2;
  }
}

/*.chart-nav-mobile {*/
/*  position: relative;*/
/*  left: 0;*/
/*  top: 0;*/
/*}*/

@media screen and (max-width: 576px) {
  /*.chart-nav #Modal2,.chart-nav #Modal1{overflow: scroll;}*/
  /*.chart-nav #Modal1 .modal-dialog,.chart-nav #Modal2 .modal-dialog{margin-top: 60px;}*/
  /*.chart-nav #Modal1 .modal-dialog .modal-content,.chart-nav #Modal2 .modal-dialog .modal-content{border: none;border-bottom: 1px solid rgba(0,0,0,.2);border-radius: 0;}*/
  /*.chart-nav #Modal2 .modal-dialog .modal-content .dropdown-item{display: flex;justify-content: flex-start;align-items: center;}*/
  /*.chart-nav #Modal2 .modal-dialog .modal-content .dropdown-item .button.scx-icon{display: flex;justify-content: center;align-items: center;width: auto;height: auto;margin:10px 10px 10px 0;}*/
  /*.chart-nav #Modal2 .modal-dialog .modal-content .dropdown-item .button.scx-icon .image.coloredBar:before{position: absolute;}*/

  /*.assets_section .container .row .chart-container-box .chart-inner {*/
  /*  margin-top: 15px;*/
  /*  padding: 0;*/
  /*}*/

  .inner.inner-new.inner-one {
    border: none;
  }

  header {
    height: 60px;
    box-shadow: 0 0 10px -3px rgba(0, 0, 0, 0.2);
  }

  .inner1 {
    box-shadow: 0 0 10px -3px rgba(0, 0, 0, 0.2);
    padding-bottom: 1rem;
  }

  header .container-fluid {
    background-image: none;
  }

  .assets_section .inner.instrument-progress1 .progressbar-line {
    margin-top: 5px;
  }

  .positive-changed,
  .negative-changed {
    font-size: 12px;
  }

  .assets_section .inner .progressbar-line {
    margin-top: 15px;
  }

  .assets_section .container .row:first-of-type .inner {
    margin-top: 21px;
  }
}

.arrow-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/*some manual fix to the bootstap because from some reason the content overflows out of the page*/
.assets_section .row {
  margin-right: inherit;
  margin-left: inherit;
  max-width: 100%;
}

.ar {
  .details {
    .one {
      text-align: right;
    }
    .three {
      text-align: left;
      padding-left: inherit;
      padding-right: 8px;
      direction: ltr;
    }
  }
  .bottom-time {
    .first-line {
      svg {transform: rotate(-90deg);}
    }
    .inner-first-line{
      svg{transform: rotate(90deg);}
    }
  }
}
</style>
